export default class db {
    static isEmptyStorageValue(value) {
        return value == null || value === '' || value === 'null' || value === 'undefined';
    }

    static clearSession() {
        localStorage.removeItem('token_professional');
        localStorage.removeItem('user');
        localStorage.removeItem('place');
        localStorage.removeItem('professionals');
        localStorage.removeItem('certifier');
        localStorage.removeItem('permissions');
        localStorage.removeItem('platform_subscription');
        localStorage.removeItem('must_setup_two_factor');

        const placeRaw = localStorage.getItem('place');
        if (!this.isEmptyStorageValue(placeRaw)) {
            try {
                const place = JSON.parse(placeRaw);
                if (place?.id_place) {
                    localStorage.removeItem(`terminal_${place.id_place}`);
                }
            } catch {
                // ignore invalid place payload
            }
        }

        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith('terminal_')) {
                localStorage.removeItem(key);
            }
        });
    }

    static storeToken(token) {
        if (this.isEmptyStorageValue(token)) {
            localStorage.removeItem('token_professional');
            return null;
        }

        localStorage.setItem('token_professional', token);
        return token;
    }

    static get token() {
        const token = localStorage.getItem('token_professional');
        return this.isEmptyStorageValue(token) ? null : token;
    }

    static get professionals() {
        const raw = localStorage.getItem('professionals');
        if (this.isEmptyStorageValue(raw)) {
            return null;
        }

        return JSON.parse(raw);
    }

    static storeProfessionals(professionals) {
        if (professionals == null) {
            localStorage.removeItem('professionals');
            return null;
        }

        localStorage.setItem('professionals', JSON.stringify(professionals));
        return professionals;
    }

    static get place() {
        const raw = localStorage.getItem('place');
        if (this.isEmptyStorageValue(raw)) {
            return null;
        }

        return JSON.parse(raw);
    }

    static storePlace(place) {
        if (place == null) {
            localStorage.removeItem('place');
            return null;
        }

        localStorage.setItem('place', JSON.stringify(place));
        return place;
    }

    static storeUser(user) {
        if (user == null) {
            localStorage.removeItem('user');
            return null;
        }

        localStorage.setItem('user', JSON.stringify(user));
        return user;
    }

    static get user() {
        const raw = localStorage.getItem('user');
        if (this.isEmptyStorageValue(raw)) {
            return null;
        }

        return JSON.parse(raw);
    }

    static get certifier() {
        const raw = localStorage.getItem('certifier');
        if (this.isEmptyStorageValue(raw)) {
            return null;
        }

        return JSON.parse(raw);
    }

    static storeCertifier(certifier) {
        if (certifier == null) {
            localStorage.removeItem('certifier');
            return null;
        }

        localStorage.setItem('certifier', JSON.stringify(certifier));
        return certifier;
    }

    static get permissions() {
        const raw = localStorage.getItem('permissions');
        if (this.isEmptyStorageValue(raw)) {
            return [];
        }

        const permissions = JSON.parse(raw);
        return Array.isArray(permissions) ? permissions : [];
    }

    static storePermissions(permissions) {
        if (permissions == null) {
            localStorage.removeItem('permissions');
            return null;
        }

        localStorage.setItem('permissions', JSON.stringify(permissions));
        return permissions;
    }

    static get platformSubscription() {
        const raw = localStorage.getItem('platform_subscription');
        if (this.isEmptyStorageValue(raw)) {
            return null;
        }

        return JSON.parse(raw);
    }

    static storePlatformSubscription(subscription) {
        if (subscription == null) {
            localStorage.removeItem('platform_subscription');
            return null;
        }

        localStorage.setItem('platform_subscription', JSON.stringify(subscription));
        return subscription;
    }

    static get terminal() {
        const data = localStorage.getItem('terminal_' + this.place?.id_place);
        if (this.isEmptyStorageValue(data)) {
            return null;
        }

        return JSON.parse(data);
    }

    static storeTerminal(terminal) {
        localStorage.setItem('terminal_' + this.place?.id_place, JSON.stringify(terminal));
        return terminal;
    }

    static removeTerminal() {
        return localStorage.removeItem('terminal_' + this.place?.id_place);
    }

    static storeMustSetupTwoFactor(value) {
        localStorage.setItem('must_setup_two_factor', value ? '1' : '0');
        return Boolean(value);
    }

    static get mustSetupTwoFactor() {
        return localStorage.getItem('must_setup_two_factor') === '1';
    }
}
